import http from '@/assets/js/common/http-common';

class AvaliacaoDiscursivaDataService {
  list() { return http.post('prova/discursiva/list', null); }
  create(data) { return http.post('prova/discursiva/create', data); }
  read(id) { return http.post('prova/discursiva/read', { id }); }
  update(data) { return http.post('prova/discursiva/update', data); }
  answers(id = null) { return http.post('prova/discursiva/answers', id ? { id } : null); }
  gradeAnswer(data) { return http.post('prova/discursiva/gradeAnswer', data); }
  alunoReadByCode(access_code) { return http.post('prova/aluno/discursiva/readByCode', { access_code }); }
  alunoSubmit(data) { return http.post('prova/aluno/discursiva/submit', data); }
  alunoMyAnswers() { return http.post('prova/aluno/discursiva/myAnswers', null); }
}

export default new AvaliacaoDiscursivaDataService();
